'use strict';
var fetchUser;

fetchUser = {
  getLsAuthCookie: function() {
    var ref;
    return ((ref = Groupon.endpoints) != null ? ref.token_exchange : void 0) && !Cookie.get('snickerdoodle');
  },
  exchangeTokenIfNeed: function(callback) {
    var ref;
    if (!this.getLsAuthCookie()) {
      callback();
      return;
    }
    return $.ajax({
      type: 'GET',
      url: (ref = Groupon.endpoints) != null ? ref.token_exchange : void 0,
      timeout: 5000,
      complete: callback
    });
  },

  /**
   * Fetch user data from endpoint
   *
   * @param {String}   userId  - User snickerdoodle id
   * @param {Function} success - Success callback
   * @param {Function} [error] - Error callback (Optional)
   */
  fetch: function(userId, success, error) {
    var ref;
    userId = userId != null ? userId.replace(/"/g, '') : void 0;
    $.ajax({
      type: 'GET',
      url: [(ref = Groupon.endpoints) != null ? ref.users : void 0, 'v1'].join('/'),
      headers: {
        'x-ls-locale': I18n.locale
      },
      timeout: 5000,
      success: function(res) {
        var err, user;
        user = res.data, err = res.err;
        if (err) {
          return error(err);
        }
        if (!user) {
          return error('No user info');
        }
        try {
          if (typeof sessionStorage !== "undefined" && sessionStorage !== null) {
            sessionStorage.setItem('verifiedUser', JSON.stringify(user));
          }
        } catch (error1) {}
        return success(user);
      },
      error: error
    });
  },

  /*
   * Removes user data from browser sessionStorage
   */
  removeUserData: function() {
    try {
      if (typeof sessionStorage !== "undefined" && sessionStorage !== null) {
        sessionStorage.removeItem('verifiedUser');
      }
    } catch (error1) {}
  },

  /**
   * @typedef  {Object}  userObject
   * @property {Boolean} hasUserData - Flag indicating that user data is stored
   * @property {String}  userId      - Snickerdoodle id
   */

  /**
   * Check for user data from Browser sessionStorage and process data if available
   *
   * @param   {Function} [noUser_cb]    - Callback executed when user is logged out (Optional)
   * @param   {Function} [hasUser_cb]   - Callback executed when user is logged in (Optional)
   * @returns {Object}   userObject
   */
  useStoredData: function(noUser_cb, hasUser_cb) {
    var data, hasUserData, ref, user, userId;
    userId = (ref = Cookie.get('snickerdoodle')) != null ? ref.replace(/"/g, '') : void 0;
    hasUserData = false;
    if (!userId) {
      this.removeUserData();
      if (noUser_cb) {
        noUser_cb();
      }
    } else {
      if ((data = typeof sessionStorage !== "undefined" && sessionStorage !== null ? sessionStorage.getItem('verifiedUser') : void 0) != null) {
        try {
          user = JSON.parse(data);
        } catch (error1) {}
        if (user && typeof user === 'object') {
          if (hasUser_cb) {
            hasUser_cb(user);
          }
          hasUserData = true;
        }
      }
    }
    return {
      hasUserData: hasUserData,
      userId: userId
    };
  }
};

module.exports = {
  fetchUser: fetchUser
};

